module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00563.f537556a.jpg";